// Path constants for the storefront subset of /api/v1.
// Source of truth: https://dev-api.bytize.in/swagger/index.html

export const endpoints = {
  public: {
    storeResolve: '/public/store/resolve',
  },
  auth: {
    customerLogin: '/customers/login',
    customerSignup: '/customers/signup',
    verifyOtp: '/customers/verify-otp',
    resendOtp: '/customers/resend-otp',
    forgotPassword: '/customers/forgot-password',
    resetPassword: '/customers/reset-password',
    refresh: '/customers/refresh',
    favoriteItems: '/customers/auth/favorite-items',
    favoriteItemsOperation: (operation) => `/customers/auth/favorite-items/${operation}`,
  },
  account: {
    profile: '/customers/auth/profile',
    changePassword: '/customers/auth/change-password',
    creditCheck: '/customers/auth/credit-check',
    customer: (id) => `/customers/${id}`,
    paymentMethods: '/account/payment-methods',
    deliveryAddress: '/customers/auth/delivery-addresses',
    deliveryAddressById: (id) => `/customers/auth/delivery-addresses/${id}`,
  },
  catalog: {
    items: '/items',
    item: (id) => `/items/${id}`,
    itemPlatformView: (id) => `/items/${id}/platform-view`,
    modifierGroup: (id) => `/modifier-groups/${id}`,
    recipeRulesItemPreview: (itemId, recipeId) =>
      `/recipe-rules/item/${itemId}/${recipeId}/preview`,
    categories: '/categories',
    categoryLevels: '/categories/levels',
    brands: '/brands',
  },
  cart: {
    active: '/carts/active',
    activeItems: '/carts/active/items',
    activeItem: (lineId) => `/carts/active/items/${lineId}`,
    checkout: '/carts/checkout',
  },
  orders: {
    my: '/customers/auth/my-orders',
    myOrder: (id) => `/customers/auth/my-orders/${id}`,
    cancelMyOrder: (id) => `/customers/auth/my-orders/${id}/cancel`,
  },
  reference: {
    countries: '/countries',
    country: (code) => `/countries/${code}`,
    countryStates: (country, state) => `/countries/${country}/${state}`,
    currencies: '/currencies',
    paymentMethods: '/payment-methods',
    locations: '/locations',
    locationById: (id) => `/locations/${id}`,
    locationBrandOrgSettings: (locationId, brandId) =>
      `/locations/${locationId}/brands/${brandId}/org-settings`,
  },
  plugins: {
    platformLocations: '/plugins/platform/locations/all',
    paymentGatewayTelrCreateOrder: '/plugins/payment-gateways/telr/orders/create',
    paymentGatewayCashfreeCreateOrder: '/plugins/payment-gateways/cashfree/orders/create',
    paymentGatewayCashfreeGetOrder: '/plugins/payment-gateways/cashfree/orders/get',
    paymentGatewayRazorpayCreateOrder: '/plugins/payment-gateways/razorpay/orders/create',
    paymentGatewayRazorpayVerifyPayment: '/plugins/payment-gateways/razorpay/payments/verify',
    paymentGatewayStripeCreatePayment: '/plugins/payment-gateways/stripe/payments/create',
    paymentGatewayStripeVerifyPayment: '/plugins/payment-gateways/stripe/payments/verify',
  },
  delivery: {
    availabilityCheck: '/delivery/availability-check',
  },
  crm: {
    referralAvailability: '/crm/referrals/availability',
  },
};
